export default __webpack_public_path__ + "static/media/mufaddal.46d6b7c1.jpg";